<template>
  <div class="mt-4">
    <button
      v-if="
        $store.state.user.sections['tickets'] && $store.state.user['is_root']
      "
      class="btn btn-danger mw"
      @click="start"
    >
      {{ "cancel_transaction" | setText("Отменить заявку") }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    currentRequest: {
      default: null,
    },
    model_type: {
      default: function () {
        return "";
      },
    },
    model_id: {
      default: function () {
        return "";
      },
    },
  },
  methods: {
    start() {
      this.$dialog
        .confirm("Вы точно хотите сбросить?", {
          okText: "Да, я хочу",
          cancelText: "Отмена",
        })
        .then(() => {
          this.cancel();
        })
        .catch(() => {});
    },

    async cancelSemurg() {
      try {
        this.$loading(true);
        //INIT
        const url = `${this.currentRequest.service.api_endpoint_url}AnnulmentTransactionRequest`;
        const method = "post";

        let data = {
          contract_id: this.currentRequest.exchange_id,
        };

        //REQUEST
        var instance = this.$http.create();
        delete instance.defaults.headers.common["Authorization"];
        delete instance.defaults.headers.common["bid"];
        delete instance.defaults.headers.common["localization"];
        delete instance.defaults.headers.common["shop"];
        delete instance.defaults.headers.common["device"];
        delete instance.defaults.headers.common["tab"];
        delete instance.defaults.headers.common["root"];
        delete instance.defaults.headers.common["version"];
        const config = {
          method: method,
          url: url,
          data: data,
          headers: {
            common: {
              Authorization:
                "Basic " +
                btoa(
                  this.currentRequest.service.api_login +
                    ":" +
                    this.currentRequest.service.api_password
                ),
            },
          },
        };

        //REQUEST
        return instance(config)
          .then((response) => {
            this.$loading(false);
            const responseData = response.data;
            return responseData;
          })
          .catch((error) => {
            this.$loading(false);
            return errorNotify(error, this.notify);
          })
          .finally(() => {
            this.$loading(false);
          });
      } catch (error) {}
    },

    async cancel() {
      if (this.currentRequest.service.code == "semurg") {
        await this.cancelSemurg();
      }

      this.$loading(true);
      await this.$http
        .delete(`cancel/${this.model_type}/${this.model_id}`)
        .then((response) => {
          this.$emit("update", true);
        })
        .catch(() => {})
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>

